import { makeStyles, TextField } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import clsx from 'clsx';
import Calendar from 'react-calendar';
import * as PROJECT_CODE from '../../constants/projectCode';
import { FirebaseContext } from '../../context/firebase';
import { updateDocumentOnly } from '../../api/Clients/updateDocumentOnly.api';

function MortgageForm({
	setShowDocInfo,
	addItemDocModal,
	setAddItemDocModal,
	clientJson,
	setLoading
}) {
	const [showCalendar, setShowCalendar] = useState(false);
	const [approvalDate, setApprovalDate] = useState(new Date());
	const { firebase } = useContext(FirebaseContext);

	const [formData, setFormData] = useState({
		lendingInstitution: '',
		agentName: '',
		mortgageValue: '',
	});

	const { lendingInstitution, agentName, mortgageValue } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
			width: '100%',
		},
		datePicker: {
			height: '36px',
			borderTop: 'none',
			borderLeft: 'none',
			borderRight: 'none',
			width: '41em',
			outline: 'none',
			borderBottom: '1px solid #949494 !important',
			marginTop: '30px',
			borderRadius: '0',
		},
		label: {
			marginBottom: '-2.3em',
			fontSize: '10px',
			color: 'grey',
		},
	}));

	const styles = useStyles();

	const handleSave = () => {
		var mortgageDetails = {
			institutionName: lendingInstitution,
			totalDownpayment: mortgageValue,
		};

		updateDocumentOnly(
			clientJson?.salesAgentPointer,
			clientJson?.keyValue,
			'mortgageDetails',
			mortgageDetails
		);

		setShowDocInfo(false);
		setAddItemDocModal({
			...addItemDocModal,
			mortgage: false,
		});
		setLoading(true)
	};


	return (
		<div className='finances_wrapper'>
			<div className={styles.root}>
				<div className='mortgage_form'>
					<TextField
						type='text'
						label='Lending Institution'
						name='lendingInstitution'
						value={lendingInstitution}
						className={styles.field}
						onChange={(e) => onChange(e)}
					/>
					<TextField
						type='text'
						label='Name of mortgage agent'
						name='agentName'
						value={agentName}
						className={styles.field}
						onChange={(e) => onChange(e)}
					/>
					<TextField
						type='number'
						label='Mortgage Value'
						name='mortgageValue'
						value={mortgageValue}
						className={styles.field}
						onChange={(e) => onChange(e)}
					/>
					{/* <TextField
							id='date'
							label='Approval date'
							type='date'
							name='approvalDate'
							value={approvalDate}
							onChange={(e) => onChange(e)}
							className={styles.field}
							InputLabelProps={{
								shrink: true,
							}}
						/> */}

					<TextField
						type='text'
						label='Approval Date'
						name='approvalDate'
						value={dayjs(approvalDate).format('DD MMMM YYYY')}
						className={styles.field}
						onChange={(e) => onChange(e)}
						onClick={() => setShowCalendar(true)}
					/>

					{showCalendar === true && (
						<div className='dates_wrapper'>
							<Calendar
								onChange={(e) => {
									setApprovalDate(new Date(e).getTime());
									setShowCalendar(false);
								}}
								value={approvalDate}
								className='new-react-calendar'
								minDate={new Date()}
								showFixedNumberOfWeeks={true}
							/>
						</div>
					)}
					<button
						className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
						onClick={() => handleSave()}
					>
						Save
					</button>
				</div>
			</div>
		</div>
	);
}

export default MortgageForm;
